













































import { Type, SetType, SetOptions, isNumber, Expression, SetOps, Exprs } from 'expangine-runtime';
import { SimpleFieldSettings } from '../../../common';
import { TypeUpdateEvent } from '../TypeVisuals';
import { SetSubs } from './SetTypes';
import TypeEditorBase from '../TypeEditorBase';


const fields: SimpleFieldSettings<SetOptions> = [];

export default TypeEditorBase<SetType, any, SetSubs>().extend({
  name: 'SetEditor',
  computed: {
    optionFields: () => fields,
    description(): string {
      return '';
    },
    requiredValue() {
      return this.requiredType && this.requiredType instanceof SetType
        ? this.requiredType.options.value
        : null;
    },
  },
  methods: {
    onChange(event: TypeUpdateEvent) {
      this.type.options.value = event.type;
      this.settings.sub.value = event.settings;

      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, SetType.STEP_VALUE, SetType.STEP_VALUE)
        : undefined;

      this.change({ transform });
    },
  },
});
